/*
 * @Description: 
 * @Version: 2.0
 * @Autor: zfj
 * @Date: 2022-02-18 21:53:06
 * @LastEditors: zfj
 * @LastEditTime: 2022-02-19 20:48:08
 */

// 导航菜单
const nav_menus=[
	{
		name:'ニュース',
		href:'https://www.itisiti.com/webnews/'
	},
	{
		name:'　会社概要',
		href:'https://www.itisiti.com/about-us/'
	},
	{
		name:'　事業内容＆サービス',
		href:'https://www.itisiti.com/service/'
	},
	{
		name:'　採用情報',
		href:'https://www.itisiti.com/careers/'
	},
	{
		name:'　問い合わせ',
		href:'https://www.itisiti.com/contact-us/'
	}
];

export {nav_menus}